import KpiCard from "../component/kpiCard"
import { Stack } from "@mui/material"
import { newCustomerCountKPI, orderAverageAllCustomerKPI, orderAverageNewCustomerKPI, totalValueNewCustomers } from "./helper"

export default function CustomerCard({ currentMonthNewCustomers, currentMonthNewCustomersSales, currentMonthAllCustomersSales, lastMonthNewCustomers, lastMonthSalesAllCustomers, lastMonthSalesNewCustomers }) {
    const cardNewCustomersCount = newCustomerCountKPI(currentMonthNewCustomers, lastMonthNewCustomers)
    const cardTotalValueNewCustomers = totalValueNewCustomers(currentMonthNewCustomersSales, lastMonthSalesNewCustomers)
    const cardOrderAverageNewCustomers = orderAverageNewCustomerKPI(currentMonthNewCustomersSales, lastMonthSalesNewCustomers, new Date())
    const cardOrderAverageAllCustomers = orderAverageAllCustomerKPI(currentMonthAllCustomersSales, lastMonthSalesAllCustomers, new Date())

    return (
        <>
            <Stack spacing={1.5}>
                <Stack direction={'row'} sx={{ flexWrap: { xs: 'wrap', sm: 'nowrap' }, gap: 1.5 }}>
                    <KpiCard {...cardNewCustomersCount} />
                    <KpiCard {...cardTotalValueNewCustomers} />
                </Stack>

                <Stack direction={'row'} sx={{ flexWrap: { xs: 'wrap', sm: 'nowrap' }, gap: 1.5 }}>
                    <KpiCard {...cardOrderAverageNewCustomers} />
                    <KpiCard {...cardOrderAverageAllCustomers} />
                </Stack>
            </Stack>
        </>
    )
}
